import { RangeControl, BaseControl } from '@wordpress/components';

const RangeSliderControl = ({ field, value, onChange, ...props }) => {
    const {
        label,
        help,
        disabled = false,
        range_config = {},
    } = field;

    const {
        min = 0,
        max = 100,
        step = 1,
    } = range_config;

    const handleChange = (val) => {
        const numericVal = Number(val);
        onChange(numericVal);
    };

    return (
        <BaseControl label={label} help={help} __nextHasNoMarginBottom>
            <RangeControl
                value={Number(value ?? min)} // Ensure it's always a number
                onChange={handleChange}
                min={Number(min)}
                max={Number(max)}
                step={Number(step)}
                disabled={disabled}
                __next40pxDefaultSize
                __nextHasNoMarginBottom
                {...props}
            />
        </BaseControl>
    );
};

export default RangeSliderControl;
